const accordionHeadlines = document.querySelectorAll('.Accordion__item-headline');

const clearAllAccordionTabs = () => {
    document.querySelectorAll('.Accordion__item')?.forEach((element) => {
        const contentElement = element.querySelector('.Accordion__item-content');
        element.classList.remove('Accordion__item--active');
        contentElement.style.maxHeight = '0px';
    });
};

const toggleAccordionTab = (ev) => {
    // clearAllAccordionTabs();
    const elementContainer = ev.currentTarget.parentElement;
    elementContainer.classList.toggle('Accordion__item--active');
    if (elementContainer.classList.contains('Accordion__item--active')) {
        elementContainer.querySelector('.Accordion__item-content').style.maxHeight = `${
            elementContainer.querySelector('.Accordion__item-content').scrollHeight
        }px`;
    } else {
        elementContainer.querySelector('.Accordion__item-content').style.maxHeight = '0px';
    }
};

accordionHeadlines?.forEach((headline) => headline.addEventListener('click', toggleAccordionTab));
// accordionHeadlines[0]?.click();
